<template>
  <div>
    <head-view></head-view>
    <Row>
      <Col span="4">
        <menus-view></menus-view>
      </Col>
      <Col span="20">
        <router-view class="xbed-oms-content"></router-view>
      </Col>
    </Row>
    <foot-view></foot-view>
  </div>
</template>

<script>
import headView from '../components/header'
import footView from '../components/footer'
import menusView from '../components/menus'

export default {
  name: 'main-page', //[Vue warn]: Do not use built-in or reserved HTML elements as component id: main
  components: {
    headView,
    footView,
    menusView
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main.vue